import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { TokenStorage } from '../storages/token.storage';

@Injectable()
export class AuthenticationGuard implements CanActivate {
  constructor(private token: TokenStorage, private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if (this.token.getToken() != null && this.token.getRole != null && this.token.getTokenLifeTime()) {

      var dateNow = new Date;
      var tokenDate = this.token.getTokenLifeTime();

      if(new Date(dateNow.toISOString()) > new Date(tokenDate) ){
        this.router.navigate(['/login']);
        console.log("token has excepted")
        return false;
      }
        
      var isChiefRole = this.token.isChiefRole();
      if (isChiefRole) {
        $('#importInNavBar').show();
      }
      else {
        $('#importInNavBar').hide();
      }
      if(isChiefRole)
      {
        $('#usersInNavBar').show();
      }
      else {
        $('#usersInNavBar').hide();
      }

      $('#navbar').show();
      return true;
    }
    this.router.navigate(['/login']);
    return false;
  }

}



// WEBPACK FOOTER //
// ./src/app/guards/authentication.guard.ts